import { render, staticRenderFns } from "./ImagesSlider.vue?vue&type=template&id=6e21fffc&scoped=true&"
import script from "./ImagesSlider.vue?vue&type=script&lang=js&"
export * from "./ImagesSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImagesSlider.vue?vue&type=style&index=0&id=6e21fffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e21fffc",
  null
  
)

export default component.exports